import { render, staticRenderFns } from "./CheeseSpecialRecommend.vue?vue&type=template&id=4509b438&"
import script from "./CheeseSpecialRecommend.vue?vue&type=script&lang=js&"
export * from "./CheeseSpecialRecommend.vue?vue&type=script&lang=js&"
import style0 from "./CheeseSpecialRecommend.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports